import { setURL } from '@/api/apiUtil'

// 服務聯繫
export default {
  // 根據社區編號取得服務聯繫列表
  getServiceContactList: {
    url: (communityId) =>
      setURL('/serviceContact/community/:communityId', { communityId }),
    method: 'get'
  },
  //根據服務聯繫編號取得服務聯繫詳細資訊
  getServiceContact: {
    url: (serviceContactId) =>
      setURL('/serviceContact/:serviceContactId', { serviceContactId }),
    method: 'get'
  },
  // 新增服務聯繫
  addServiceContact: {
    url: setURL('/serviceContact'),
    method: 'post'
  },
  // 根據服務聯繫編號修改服務聯繫
  editServiceContact: {
    url: (serviceContactId) =>
      setURL('/serviceContact/:serviceContactId', { serviceContactId }),
    method: 'put'
  },
  // 根據服務聯繫編號刪除服務聯繫
  deleteServiceContact: {
    url: (serviceContactId) =>
      setURL('/serviceContact/:serviceContactId', { serviceContactId }),
    method: 'delete'
  },
  // 根據服務聯繫編號置頂服務聯繫
  pinServiceContact: {
    url: (serviceContactId) =>
      setURL('/serviceContact/:serviceContactId/top', { serviceContactId }),
    method: 'put'
  },
  // 根據服務聯繫編號取消置頂服務聯繫
  cancelPinServiceContact: {
    url: (serviceContactId) =>
      setURL('/serviceContact/:serviceContactId/cancel-top', {serviceContactId}),
    method: 'put'
  }
}
